import { TLCEventManager } from "../../../js/lib/events/EventManager";
import { TLCEvents } from "../../../js/lib/events/events";
import { TLCLogger } from "../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../js/main/constants";
import { ApplicationData } from "../ls2pac/ApplicationData";
import { ResourceClientManager } from "../ls2pac/ClientManagers/ResourceClientManager";
import { LS2PAC_Utils } from "../ls2pac/utils/Utils";
import { ResourceUtils } from "../ls2pac/utils/resourceUtils";
import { LS2KIDS_CONSTANTS } from "./constants";
import { KidsGoogleAnalyticsManager } from "./managers/GoogleAnalyticsManager";
import { KidsSearchDatabaseManager } from "./managers/SearchDatabaseManager";
import { KidsMessaging } from "./messaging";

/**
 * Contains all the routes that the application can handle. Routes are mapped from a URL to an event that will
 * be fired from TLCEventManager.
 * tlc.ls2kids.RoutesTable
 */
export class KidsRoutesTable {
	constructor() {
		this._routes = {};
		this._initialLoad = true;
		this.addRoutes();
	}
	/**
	 * Add all the routes.
	 */
	addRoutes() {
		var _this = this;

		this.addRoute(
			LS2KIDS_CONSTANTS.Urls.home,
			LS2KIDS_CONSTANTS.Events.onStartAutoCycle
		);

		this.addRoute(
			LS2KIDS_CONSTANTS.Urls.error,
			function (event) {
				var message = ResourceUtils.getFrownIcon() + " Something went wrong";

				switch (event.type) {
					case "ssoError":
						message = ResourceUtils.getFrownIcon() + " " + ApplicationData.language.kidsSsoError;

						KidsMessaging.confirm({
							message: message,
							failButton: ApplicationData.language.kidsStayHere,
							failCallback: function () {
								TLCEventManager.fireEvent(LS2KIDS_CONSTANTS.Events.onStartAutoCycle);
							}
						});
						break;
					case "ssoErrorStack":
						if (window.SPRING_SECURITY_LAST_EXCEPTION_MESSAGE) {
							message = ResourceUtils.getFrownIcon() + " " + window.SPRING_SECURITY_LAST_EXCEPTION_MESSAGE + "<br>";
						}
						if (window.SPRING_SECURITY_LAST_EXCEPTION_CAUSE) {
							message += window.SPRING_SECURITY_LAST_EXCEPTION_CAUSE;
						}

						KidsMessaging.confirm({
							message: message,
							failButton: ApplicationData.language.kidsStayHere,
							failCallback: function () {
								TLCEventManager.fireEvent(LS2KIDS_CONSTANTS.Events.onStartAutoCycle);
							}
						});
						break;
					default:
						KidsMessaging.show(message);
						break;
				}
			}
		);

		this.addRoute(
			LS2KIDS_CONSTANTS.Urls.categories,
			LS2KIDS_CONSTANTS.Events.onStartCategoryView
		);

		this.addRoute(
			LS2KIDS_CONSTANTS.Urls.series,
			function () {
				return LS2KIDS_CONSTANTS.Events.onStartSeriesView;
			}
		);

		this.addRoute(
			LS2KIDS_CONSTANTS.Urls.search,
			function () {
				KidsSearchDatabaseManager.setCurrentDatabaseKey(
					LS2KIDS_CONSTANTS.searchDatabases.ls2pac
				);

				return LS2PAC_CONSTANTS.Events.onSearch;
			}
		);

		this.addRoute(
			LS2KIDS_CONSTANTS.Urls.categorySearch,
			function () {
				KidsSearchDatabaseManager.setCurrentDatabaseKey(
					LS2KIDS_CONSTANTS.searchDatabases.category
				);

				return LS2PAC_CONSTANTS.Events.onSearch;
			}
		);

		this.addRoute(
			LS2KIDS_CONSTANTS.Urls.seriesSearch,
			function () {
				KidsSearchDatabaseManager.setCurrentDatabaseKey(
					LS2KIDS_CONSTANTS.searchDatabases.series
				);

				return LS2PAC_CONSTANTS.Events.onSearch;
			}
		);

		this.addRoute(
			LS2KIDS_CONSTANTS.Urls.fullDetails,
			function (event) {
				_this.overlayPage(event);

				if (event.history.previous.url == event.history.current.url) {
					event.history.previous = {
						url: LS2KIDS_CONSTANTS.Urls.__start,
						query: {}
					};
				}

				var resource = KidsSearchDatabaseManager.getResourcebyId(event.resourceId);

				if (resource) {
					var data = LS2PAC_Utils.getFakePagingDataToSendToFullDetails([resource]);
					data.currentResource = data.resourceData.resources[data.index];
					data.history = event.history;
					TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onShowFullDetails, data);
					return;
				}

				return ResourceClientManager.getResourceByIdEvent;
			}
		);
	}
	overlayPage(event) {
		if (this._initialLoad) {
			event.history.previous = {
				url: LS2KIDS_CONSTANTS.Urls.__start,
				query: {}
			};

			if (LS2KIDS_CONSTANTS.Urls.__start == LS2KIDS_CONSTANTS.Urls.categories) {
				TLCEvents.trigger(LS2KIDS_CONSTANTS.Events.onStartCategoryView);
			} else {
				TLCEvents.trigger(LS2KIDS_CONSTANTS.Events.onStartSeriesView);
			}

		}

		return event;
	}
	/**
	 * Execute the route, this will fire an event for the given URL and any data.
	 * @param {string} url the url that should be triggered
	 * @param {*=} eventData extra event data to be passed to the event listener
	 */
	route(url, eventData) {
		var routes = this.getRoute(url);

		for (var i = 0, len = routes.length; i < len; i += 1) {
			var nextRoute = routes[i];

			if (typeof nextRoute === 'string') {
				TLCLogger.log('routing to: ', nextRoute);

				TLCEventManager.fireEvent(nextRoute, eventData);

			} else if (typeof nextRoute === 'function') {
				var nextEvent = nextRoute.call(window, eventData);

				if (typeof nextEvent === 'string') {
					TLCEventManager.fireEvent(nextEvent, eventData);
				}
			}
		}

		KidsGoogleAnalyticsManager.urlChange(url, eventData);

		this._initialLoad = false;
	}
	/**
	 * Helper method to add routes to the hash.
	 * @param {string} url the url we want to map
	 * @param {string|function():string==} eventOrCallback an event or an optional callback with optional return string
	 */
	addRoute(url, eventOrCallback) {
		if (!this._routes[url]) {
			this._routes[url] = [];
		}

		this._routes[url].push(eventOrCallback);
	}
	/**
	 * Get the event for a route.
	 * @param {string} url
	 * @return {Array.<string|function():string=>|string|function():string=} the event or callback function the url should route to
	 */
	getRoute(url) {
		return this._routes[url];
	}
}

/**
 * A map of all the routes
 * @private
 * @type {Object.<string,Array.<string|function():string=>>}
 */
KidsRoutesTable.prototype._routes = null;
KidsRoutesTable.prototype._initialLoad = null;










